import React from 'react'
import PT from 'prop-types'
import { ButtonIcon } from 'common/auth/Shared/AuthModalV2'
import Icon from 'components.v2/Icon/IconV2'
import capitalize from 'lodash/capitalize'
import { Text } from 'components/v2/styled'

/**
 * Note: this is dumb component, stateful version is available in the same name in `common/auth` folder
 */

const SocialButton = ({
  actionText = 'Login with',
  extended,
  variant,
  className,
  ...props
}) => (
  <ButtonIcon variant={variant} className={className} {...props}>
    <Icon
      src={
        {
          facebook: 'GuestFacebook.svg',
          google: 'GuestGoogle.svg',
        }[variant]
      }
    />
    {extended && (
      <Text fontWeight="700" size="16px" height="28px" color="#666" >
        {actionText} {capitalize(variant)}
      </Text>
    )}
  </ButtonIcon>
)

SocialButton.propTypes = {
  variant: PT.oneOf(['facebook', 'google']),
  /** if true, text with read "Sign up with <SocialMediaName>" instead of "<SocialMediaName>" */
  extended: PT.bool,
  actionText: PT.string,
}

export default SocialButton
